module.exports = __webpack_public_path__ + "img/cpzz12@2x.3b49c453.png";